import { Controller } from "@hotwired/stimulus"

const CSS_CLASSES = { isLoading: "is--loading" }

export default class extends Controller {
  static targets = ["form"]

  handleFileInputChange(_event) {
    if (!this.hasFormTarget) { return }
    this.formTarget.requestSubmit()
  }

  uploadStarted(_event) {
    this.element.classList.add(CSS_CLASSES.isLoading)
  }
}
